export * from "./configManager";
